import Joi from 'joi';
import rutValidator from 'rut-validator-ca';

const custom = Joi.extend({
  messages: {
    invalidRut: 'Rut inválido (formato sin puntos y con guión: 12345678-9)',
  },
  type: 'rut',
  rules: {
    validateRut: {
      validate(value, helpers) {
        if (rutValidator(value) && value !== '') return true;
        else return helpers.error('invalidRut');
      },
    },
  },
});

export const schema = Joi.object({
  thirdId: custom.rut().validateRut(),
  thirdName: Joi.string()
    .min(3)
    .error(new Error('Nombre de tercero es requerido')),
  thirdEmail: Joi.string()
    .email({ tlds: { allow: false } })
    .error(new Error('Email es requerido')),
});
